import { SummaryBlock } from '@api';
import { useClassNames } from '@common';
import { SummaryBlockItemWitCoord } from '@components';
import React, { useMemo } from 'react';
import { TaskItem } from './TaskItem';
import './Tasks.scss';
import { cloneDeep } from 'lodash';
import { HintIcon } from '@icons';

interface TaskListProps {
	className?: string,
	tasks: SummaryBlockItemWitCoord[],
	selectedTasks?: string[],

	onUpdateSummaryData: (updatedSummaryData: SummaryBlock[]) => void,
	canEditResume: boolean,
	allowSelection?: boolean,
	summaryBlocks: SummaryBlock[],
	onChangeSelection?: (changedItemId: string) => void,
}

function TaskList(props: TaskListProps): JSX.Element {
	const {
		className,
		onUpdateSummaryData,
		canEditResume,
		allowSelection,
		tasks,
		summaryBlocks,
		selectedTasks,
		onChangeSelection,
	} = props;

	
	
	const itemsView = useMemo(() => {		
		if (tasks.length) {
			const handleEdit = (newItem: SummaryBlockItemWitCoord) => {
				const newSummaryBlocks: SummaryBlock[] = cloneDeep(summaryBlocks);
				newSummaryBlocks[newItem.blockIndex].items[newItem.itemIndex] = newItem.item;
				onUpdateSummaryData(newSummaryBlocks);
			};

			return tasks.map((task) => <TaskItem
				allowSelection={allowSelection}
				onChangeSelection={onChangeSelection}
				isSelected={selectedTasks && selectedTasks.includes(task.item.id)}
				key={task.item.id}
				task={task}
				onEdit={handleEdit}
				canEditResume={canEditResume}
			/>);
		} else {
			return <div className='task-list__hint'>
			<div className='task-list__hint_icon'>
				<HintIcon />
			</div>
			<div>
				Список задач пуст. <br/>Задайте исполнителя и срок у пункта протокола, чтобы он стал задачей.
			</div>
		</div>
		}

	}, [tasks, summaryBlocks, canEditResume, onUpdateSummaryData, selectedTasks, allowSelection, onChangeSelection]);

	const classes = useClassNames(
		'task-list',
		className,
	);
	
	return (
		<div className={classes}>
			{itemsView}
		</div>
	);
}

const MemoisedTaskList = React.memo(TaskList);
export {MemoisedTaskList as TaskList};